import classNames from 'classnames';
import * as Icons from 'icons';
import styles from './Keyboard.module.scss';

export default function Keyboard({ onPress, onBack, onSubmit }) {
  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div className={styles.button} onClick={event => onPress('1')}>1</div>
        <div className={styles.button} onClick={event => onPress('2')}>2</div>
        <div className={styles.button} onClick={event => onPress('3')}>3</div>
        <div className={styles.button} onClick={event => onPress('4')}>4</div>
        <div className={styles.button} onClick={event => onPress('5')}>5</div>
        <div className={styles.button} onClick={event => onPress('6')}>6</div>
        <div className={styles.button} onClick={event => onPress('7')}>7</div>
        <div className={styles.button} onClick={event => onPress('8')}>8</div>
        <div className={styles.button} onClick={event => onPress('9')}>9</div>
        <div className={styles.button} onClick={onBack}>
          <Icons.Delete />
        </div>
        <div className={styles.button} onClick={event => onPress('0')}>0</div>
        <div className={classNames(styles.button, styles.dark)} onClick={onSubmit}>
          <Icons.Submit />
        </div>
      </div>
    </div>
  )
}